import { createWebHistory, createRouter } from "vue-router";

import Home from "@/views/HomeUser.vue";
import AmlakList from "@/views/AmlakList.vue";
import CategoryPage from "@/views/CategoryPage.vue";
import DetailsPost from "@/views/DetailsPost.vue";
import NotFound from "@/views/NotFound.vue";
import ProfileAmlak from "@/views/profileAmlak.vue";
import mapMelk from "@/views/mapMelk.vue";
import createMelk from "@/components/profile/createMelk.vue";
import walletUser from "@/views/walletUser.vue";
import bookMark from "@/views/bookMark.vue";
import myAds from "@/views/myAds.vue";
import ProfileInstagram from "@/views/ProfileInstagram.vue";
import aboutUS from "@/views/aboutUS.vue";
import contactUS from "@/views/contactUS.vue";
import BuildingList from "@/views/BuildingList.vue";
import paymentList from "@/views/paymentList";
import ChatSystem from "@/views/ChatSystem";
// import firstPage from "@/views/firstPage";
import store from "../store";
import auth from "../auth.middlware.js";
import newsPage from "@/views/newsPage.vue";
import newsDetails from "@/views/newsDetails.vue";
import amlakMap from "@/views/amlakMap.vue";
import amlakRegion from "@/views/amlakRegion.vue";
import guidPage from "@/views/guidePage.vue";
import commissionCalculator from "@/views/commissionCalculator.vue";
import propertyEvaluator from "@/views/propertyEvaluator.vue";
import complaintPage from "@/views/complaintPage.vue";
import complaintTracking from "@/views/complaintTracking.vue";
import profileBuilder from "@/views/profileBuilder.vue";
import builderPostDetails from "@/views/builderPostDetails.vue";
import builderCreatePost from "@/views/builderCreatePost.vue";
import dektopPostBuilder from "@/views/desktopPostBuilder.vue";
import myProfileBuilder from "@/views/myProfileBuilder.vue";

const routes = [
  // { path: "/", name: "firstPage", component: firstPage },
  { path: "/", redirect: "/home" },
  { path: "/home", name: "HomeUser", component: Home },
  {
    path: "/category",
    name: "CategoryPage",
    component: CategoryPage,
    props: true,
  },
  {
    path: "/details/:id?/:type?",
    name: "DetailsPost",
    component: DetailsPost,
    props: true,
  },
  {
    path: "/profile/:page?",
    name: "amlakProfile",
    component: ProfileAmlak,
    meta: { middleware: [auth] },
  },
  {
    path: "/user-profile/:comp?",
    name: "myProfileBuilder",
    component: myProfileBuilder,
    meta: { middleware: [auth] },
  },
  {
    path: "/profile-builder",
    name: "profileBuilder",
    component: profileBuilder,
  },
  {
    path: "/builder-details/:userId?/:id?",
    name: "builderPostDetails",
    component: builderPostDetails,
  },
  {
    path: "/builder-post-details/:userId?/:id?",
    name: "dektopPostBuilder",
    component: dektopPostBuilder,
  },
  {
    path: "/builder-create-post/:id?",
    name: "builderCreatePost",
    component: builderCreatePost,
    meta: { middleware: [auth] },
  },
  { path: "/map-house", name: "mapMelk", component: mapMelk },
  {
    path: "/submit-house",
    name: "createMelk",
    component: createMelk,
    meta: { middleware: [auth] },
  },
  {
    path: "/wallet",
    name: "creditUser",
    component: walletUser,
    meta: { middleware: [auth] },
  },
  {
    path: "/bookmark",
    name: "BookmarkPage",
    component: bookMark,
    meta: { middleware: [auth] },
  },
  {
    path: "/myads",
    name: "myAds",
    component: myAds,
    meta: { middleware: [auth] },
  },
  {
    path: "/profile-personal",
    name: "instagramProfile1",
    component: ProfileInstagram,
  },
  {
    path: "/profile-superior",
    name: "instagramProfile2",
    component: ProfileInstagram,
  },
  {
    path: "/profile-amlak",
    name: "instagramProfile3",
    component: ProfileInstagram,
  },
  {
    path: "/commission-calculator",
    name: "commissionCalculator",
    component: commissionCalculator,
  },
  {
    path: "/property-evaluator/:result?",
    name: "propertyEvaluator",
    component: propertyEvaluator,
  },
  {
    path: "/complaint",
    name: "complaintPage",
    component: complaintPage,
    meta: { middleware: [auth] },
  },
  {
    path: "/complaint-tracking",
    name: "complaintTracking",
    component: complaintTracking,
  },
  { path: "/about-us", name: "AboutUs", component: aboutUS },
  { path: "/guide", name: "guidPage", component: guidPage },
  { path: "/contact-us", name: "contactUs", component: contactUS },
  { path: "/amlak-list", name: "amlakList", component: AmlakList },
  { path: "/users-list", name: "buildersList1", component: BuildingList },
  { path: "/top-users", name: "buildersList2", component: BuildingList },
  { path: "/payment-list", name: "paymentList", component: paymentList },
  { path: "/chat", name: "systemChat", component: ChatSystem },
  { path: "/news", name: "newsPage", component: newsPage },
  { path: "/news-details", name: "newsDetails", component: newsDetails },
  { path: "/map-amlak", name: "mapAmlak", component: amlakMap },
  { path: "/amlak-region", name: "amlakRegion", component: amlakRegion },

  {
    path: "/:pathMatch(.*)*",
    name: "NotFound",
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return { ...savedPosition, behavior: "instant" };
    } else {
      return { top: 0, left: 0, behavior: "instant" };
    }
  },
});

// router.beforeEach((to, from, next) => {
//   const userAgent = navigator.userAgent;
//   if (to.path == "/") {
//     if (userAgent.includes("Windows") || userAgent.includes("Macintosh")) {
//       next("/home");
//     } else {
//       next();
//     }
//   } else {
//     next();
//   }
// });

router.beforeEach((to, from, next) => {
  if (!to.meta.middleware) {
    return next();
  }
  const context = {
    to,
    from,
    next,
    store,
  };
  return to.meta.middleware[0]({
    ...context,
  });
});

export default router;
